import _directionDownLine from "@zenlayer/zen-design-icons/assets/direction/DownLine.svg";
import _suggestCloseCircleLine from "@zenlayer/zen-design-icons/assets/suggest/CloseCircleLine.svg";
import { useControllableValue } from 'ahooks';
import { Cascader as AntdCascader } from 'antd';
import classNames from 'classnames';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { error as errorLog } from '../_util/devConsoleLog';
import Chips from '../chips';
import Icon from '../icon';
import { NotFoundContent } from '../select';
import TextField from '../text-field';
import { jsx as _jsx } from "react/jsx-runtime";
const {
  SHOW_CHILD,
  SHOW_PARENT
} = AntdCascader;
const Cascader = props => {
  const {
    label,
    placeholder,
    type = 'outline',
    size = 'm',
    disabled,
    error,
    loading,
    optionsLoading,
    multiple,
    mText,
    maxTagCount,
    showCheckedStrategy,
    displayRender,
    allowClear,
    options,
    prefix,
    onFocus,
    onBlur,
    open,
    onDropdownVisibleChange,
    fieldNames,
    showSearch,
    searchValue,
    onSearch,
    getPopupContainer,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    width,
    className,
    style,
    ...restProps
  } = props;
  const baseClassName = "".concat(prefixClass, "-cascader");
  useEffect(() => {
    errorLog(label !== undefined && placeholder !== undefined, 'Cascader', "'label' and 'placeholder' cannot be shared.");
    errorLog(mText !== undefined && props.maxTagCount === 'responsive', 'Cascader', "'mText' and 'maxTagCount ==='responsive'' cannot be shared.");
  }, []);
  const antdCascaderRef = useRef(null);
  const [value, onChange] = useControllableValue(props, {
    defaultValue: undefined,
    defaultValuePropName: 'defaultValue',
    valuePropName: 'value',
    trigger: 'onChange'
  });
  const [isFocus, setFocus] = useState(false);
  const canDoSomething = !disabled;
  const shrink = useMemo(() => {
    if (isFocus) {
      return true;
    } else {
      if (multiple) {
        return !!(value !== null && value !== void 0 && value.length);
      } else {
        return !!value;
      }
    }
  }, [isFocus, multiple, value]);
  const suffixIcon = useMemo(() => {
    if (mText) {
      return undefined;
    }
    return allowClear && (Array.isArray(value) ? value.length > 0 : value !== undefined) ? /*#__PURE__*/_jsx(Icon, {
      type: "suggest/CloseCircleLine",
      onClick: () => {
        onChange(undefined);
      },
      style: {
        cursor: 'pointer',
        zIndex: 2,
        pointerEvents: 'auto'
      }
    }) : /*#__PURE__*/_jsx(Icon, {
      type: "direction/DownLine",
      fontSize: 16
    });
  }, [mText, allowClear, value]);
  const AntdCascaderRender = /*#__PURE__*/_jsx(AntdCascader, {
    ref: antdCascaderRef,
    multiple: multiple,
    placeholder: placeholder,
    value: value,
    onChange: onChange,
    disabled: disabled,
    className: classNames('content', {
      ["".concat(size)]: !!size,
      ["with-prefixIcon"]: !!prefix,
      ["with-suffixIcon"]: !!true
    }),
    popupClassName: "".concat(baseClassName, "-dropdown"),
    variant: "borderless",
    onFocus: e => {
      if (canDoSomething) {
        onFocus === null || onFocus === void 0 || onFocus(e);
        setFocus(true);
      }
    },
    onBlur: e => {
      if (canDoSomething) {
        onBlur === null || onBlur === void 0 || onBlur(e);
        setFocus(false);
      }
    },
    open: open,
    onDropdownVisibleChange: open => {
      if (canDoSomething) {
        if (multiple) {
          var _antdCascaderRef$curr;
          setFocus(open);
          (_antdCascaderRef$curr = antdCascaderRef.current) === null || _antdCascaderRef$curr === void 0 || _antdCascaderRef$curr.blur();
        }
        onDropdownVisibleChange === null || onDropdownVisibleChange === void 0 || onDropdownVisibleChange(open);
      }
    },
    allowClear: false,
    suffixIcon: false,
    notFoundContent: /*#__PURE__*/_jsx(NotFoundContent, {
      optionsLoading: optionsLoading
    }),
    options: options,
    showSearch: showSearch,
    searchValue: searchValue,
    onSearch: onSearch,
    maxTagCount: maxTagCount,
    showCheckedStrategy: showCheckedStrategy,
    displayRender: displayRender,
    getPopupContainer: getPopupContainer,
    fieldNames: fieldNames
  });
  if (label === undefined) {
    return /*#__PURE__*/_jsx(Chips, {
      type: type,
      size: size,
      disabled: disabled,
      mText: mText,
      error: error,
      loading: loading,
      prefix: prefix,
      suffix: suffixIcon,
      style: style,
      width: width,
      noPadding: true,
      className: classNames(className, "".concat(baseClassName, "-forChips")),
      ...restProps,
      children: AntdCascaderRender
    });
  }
  return /*#__PURE__*/_jsx(TextField, {
    label: label,
    type: type,
    shrink: shrink,
    isFocus: isFocus,
    size: size,
    disabled: disabled,
    mText: mText,
    error: error,
    loading: loading,
    prefix: prefix,
    suffix: suffixIcon,
    style: style,
    width: width,
    className: classNames(className, baseClassName),
    ...restProps,
    children: AntdCascaderRender
  });
};
Cascader.SHOW_PARENT = SHOW_PARENT;
Cascader.SHOW_CHILD = SHOW_CHILD;
export default Cascader;